import { Controller } from 'front-end-core/core/Router'
import Main from './Main'
import Header from './Header'
import getUrl from 'front-end-core/core/url'
import { LEGISLATION, LEGISLATION_REVIEW, LEGISLATION_FOLDERS } from 'constants/controllers'
import { URL_PDF_LEG } from 'constants/urls'

export default new Controller({
  name: LEGISLATION_REVIEW,
  route: ':aol/legreview/:selectedIds',
  controller (
    Router,
    { url: pageId, scrollMain, query: { short }, params: { aol, selectedIds } },
    render
  ) {
    render(
      { Header, Main },
      {
        selectedIds: selectedIds.split(','),
        short,
        pdfUrl: URL_PDF_LEG,
        aol,
        returnUrl: getUrl(LEGISLATION_FOLDERS, { aol }),
        returnText: 'Legislation menu'
      },
      {
        aol,
        pageId,
        searchType: 'legislation',
        className: 'legislation content-review',
        bottleLink: flavour => getUrl(LEGISLATION, { aol })
      }
    )

    return pageId
  }
})
